module.exports = __webpack_public_path__ + "img/page-header-bg.9b7be954.jpeg";